<template>
  <div
    class="star-rating"
    :class="{
      'controlled': controlled
    }"
  >
    <div class="star-rating-container">
      <span
        v-for="item in reversedLevels"
        :key="item"
        class="rate"
        :class="{
          checked: item === Math.ceil(rate),
          'star-half': isStarHalf(rate, item)
        }"
        :style="{
          '--size': size
        }"
        @click="handleClick(item)"
      >

        <aha-svg
          v-if="isStarHalf(rate, item)"
          name="star-half"
          :width="size"
          :height="size"
          viewBox="0 0 20 20"
          :maintainColor="true"
        />
        <aha-svg
          v-else
          name="star-fill"
          :width="size"
          :height="size"
          viewBox="0 0 20 20"
        />
      </span>
    </div>
  </div>
</template>

<script>
import AhaSvg from './Svg.vue'

export default {
  components: {
    AhaSvg,
  },
  props: {
    levels: {
      type: Number,
      default: 5,
    },
    rate: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: '20px',
    },
    controlled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    reversedLevels() {
      return [...Array(this.levels).keys()].map((i) => i + 1).reverse()
    },
  },
  methods: {
    handleClick(value) {
      if (!this.controlled) return

      this.$emit('onChange', value)
    },
    isStarHalf(rate, item) {
      return item - rate > 0 && item - rate < 1
    },
  },
}
</script>

<style lang="scss" scoped>
$base-color: #D3D7E1;
$active-color: #FFA826;

.star-rating {
  &-container {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}

.rate {
  display: inline-block;
  font-size: var(--size);
  color: $base-color;

  &.checked:not(.star-half) {
    color: $active-color;
  }

  &.checked ~ & {
    color: $active-color;
  }

  &:not(:first-child) {
    margin-right: calc(var(--size) / 10);
  }
}

@media screen and (min-width: 1200px) {
  .star-rating.controlled {
    cursor: pointer;

    .rate:hover,
    .rate:hover ~ .rate {
      color: $active-color;
    }
  }
}
</style>
